module.exports = "/_next/static/images/icon-join-3323d381a037bfe090946ba59515ba39.png";